import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { BffUserPortalApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class BffUserPortalApiModule {
    public static forRoot(configurationFactory: () => BffUserPortalApiConfiguration): ModuleWithProviders<BffUserPortalApiModule> {
        return {
            ngModule: BffUserPortalApiModule,
            providers: [ { provide: BffUserPortalApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: BffUserPortalApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BffUserPortalApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
